import React, { useState, useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { Sidenav, DashboardNavbar, Footer } from "@/widgets/layout";
import { getRoutes } from "@/routes";
import { useMaterialTailwindController } from "@/context";
import Permission from "../components/Permission";
import NotFound from "@/pages/errors/404";
import { matchPath } from "react-router-dom";
import { useTranslation } from "react-i18next";


export function Dashboard() {
  const [controller] = useMaterialTailwindController();
  const { sidenavType } = controller;
  const location = useLocation();
  const { i18n, t } = useTranslation("sidebar");
  const routes = getRoutes(t);

  const [sidenavCollapsed, setSidenavCollapsed] = useState(
    () => localStorage.getItem("sidenavCollapsed") === "1"
  );

  useEffect(() => {
    const handler = (e) => setSidenavCollapsed(e.detail.collapsed);
    window.addEventListener("sidenavToggle", handler);
    return () => window.removeEventListener("sidenavToggle", handler);
  }, []);

  const dashboardPaths = routes
    .filter(({ layout }) => layout === "dashboard")
    .flatMap(({ pages }) => pages.map((page) => `/dashboard${page.path.startsWith("/") ? page.path : `/${page.path}`}`));

  const isValidDashboardRoute = dashboardPaths.some((routePath) =>
    matchPath({ path: routePath, end: true }, location.pathname)
  );

  if (!isValidDashboardRoute) {
    return <NotFound />;
  }

  return (
    <div className="min-h-screen bg-blue-gray-50/50">
      <Sidenav
        routes={routes}
        brandImg={
          sidenavType === "dark"
            ? "/img/logologos/.png"
            : "/img/logos/logo.png"
        }
      />
      <div className={`p-4 transition-all duration-300 ${sidenavCollapsed ? "lg:ml-[68px]" : "lg:ml-[286px]"}`}>
        <DashboardNavbar />

        <Routes key={i18n.language}>
          {routes.map(
            ({ layout, pages }) =>
              layout === "dashboard" &&
              pages.map(({ path, element, permission = null }) => (
                <Route
                  key={path}
                  path={path}
                  element={
                    <Permission required={permission}>{element}</Permission>
                  }
                />
              ))
          )}
        </Routes>

        <div className="text-blue-gray-600">
          <Footer />
        </div>
      </div>
    </div>
  );
}

Dashboard.displayName = "/src/layout/dashboard.jsx";
export default Dashboard;